let authorCard = document.querySelector('[data-author-card]')

let init = function init() {
  if (!isSlideShow()) {
    displayAuthorCard()
  }
}

let hideAuthorCard = function hideAuthorCard() {
  if (authorCard) {
    authorCard.style.display = 'none'
  }
}

let displayAuthorCard = function displayAuthorCard() {
  if (authorCard) {
    authorCard.style.display = 'inherit'
  }
}

let isSlideShow = function isSlideShow() {
  let slideElem = document.head.querySelector('[name=Slideshow]')
  return (slideElem && slideElem.content === 'true') || false
}

let isLastSlide = function isLastSlide(slideCount, currentSlide) {
  return slideCount > 0 && currentSlide === slideCount
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

document.addEventListener('slideChange', function(e) {
  if (isLastSlide(e.detail.slideCount, e.detail.currentSlide)) {
    displayAuthorCard()
  } else {
    hideAuthorCard()
  }
})
